/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Package, Package$inboundSchema } from "./package.js";

export type UpdatePackageResult = {
  package: Package;
};

/** @internal */
export const UpdatePackageResult$inboundSchema: z.ZodMiniType<
  UpdatePackageResult,
  unknown
> = z.object({
  package: Package$inboundSchema,
});

export function updatePackageResultFromJSON(
  jsonString: string,
): SafeParseResult<UpdatePackageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdatePackageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdatePackageResult' from JSON`,
  );
}
